import { BuyTicketApi } from 'shared/api/BuyTicket'
import { TourDocumentApi } from 'shared/api/tours/document-data'
import { startPaymentFromConfirmResult } from 'shared/lib/payment-start'

import { parsePaymentAmount, serializePaymentAmount } from './payment-amount'
import type { TourDocumentView } from './types'

export type AdditionalTourPaymentIssue =
  | 'invalid'
  | 'exceeds'
  | 'startFailed'
  | 'requestFailed'
  | 'refreshFailed'

export const startAdditionalTourPayment = async (
  document: TourDocumentView,
  value: string | null,
): Promise<AdditionalTourPaymentIssue | null> => {
  const remaining = parsePaymentAmount(document.remainingAmountRaw)
  const amount = value === null ? remaining : parsePaymentAmount(value)
  if (amount === null || amount <= 0n) return 'invalid'
  if (remaining === null || amount > remaining) return 'exceeds'

  const { data } = await TourDocumentApi.createAdditionalPayment(document.id, {
    amount: serializePaymentAmount(amount),
  })
  if (data.status !== 'success') return 'startFailed'

  const { data: paymentResult } = await BuyTicketApi.buyTicketConfirm({
    id: document.id,
    type: 'tours',
  })
  const started = await startPaymentFromConfirmResult(paymentResult, {
    allowDisabledFallback: false,
  })
  return started ? null : 'startFailed'
}
